<template>
  <div class="flex flex-col w-full my-12 py-8 px-6 space-y-6 border rounded-lg bg-[#FFFFFF0D] border-[#ffffff1a]">
    <div class="space-y-2">
      <h2 class="text-center uppercase">Sign In</h2>
      <p class="text-sm text-center text-muted-foreground">Enter your credentials to access your account</p>
    </div>
    <LoginSocial class="w-full" @on-success="emit('login-success')" />
    <Separator label="Or continue with email" class="separator my-6" />
    <LoginForm @submit="onSubmitLogin" />

    <div v-if="props.onBack" class="flex flex-col w-full items-center justify-center space-y-4">
      <Button
        variant="ghost"
        size="sm"
        class="text-muted-foreground flex items-center gap-x-1"
        @click="props.onBack"
      >
        <ArrowLeftIcon class="w-4 h-4" />
        Back
      </Button>
    </div>

    <slot name="footer" />
  </div>
</template>

<script setup lang="ts">
import { ArrowLeftIcon } from 'lucide-vue-next'
import { useToast } from '~/components/ui/toast'

const props = defineProps<{
  onBack?: () => void
}>()

const emit = defineEmits<{
  (e: 'login-success'): void
}>()

const { create } = useUser()
const { toast } = useToast()

const onSubmitLogin = async (values: { email: string; password: string }) => {
  try {
    await create({ email_address: values.email ?? '', password: values.password ?? '' })
    emit('login-success')
  } catch {
    toast({
      title: 'Login Failed',
      description: 'Invalid email or password. Please try again.',
      variant: 'destructive',
    })
  }
}
</script>

<style scoped>
:deep(.separator > span) {
  background-color: #1b5275;
}
</style>
